// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { TradePartnerInfoFragmentDoc } from '../../bills/BillsPage.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LienWaiverPdfQueryVariables = Types.Exact<{
  lienWaiverId: Types.Scalars['ID']['input'];
}>;


export type LienWaiverPdfQuery = { __typename?: 'Query', lienWaiver: { __typename?: 'LienWaiver', id: string, payerName: string, amountInCents: number, throughDate?: Types.Scalars['Date']['input'] | null | undefined, parent:
      | { __typename?: 'StandaloneProject' }
      | { __typename?: 'Region' }
      | { __typename?: 'Bill', id: string, invoiceNumber: string }
      | { __typename?: 'Invoice', id: string, invoiceNumber: string }
      | { __typename?: 'Market' }
      | { __typename?: 'Community' }
      | { __typename?: 'Subdivision' }
      | { __typename?: 'Lot' }
      | { __typename?: 'Structure' }
      | { __typename?: 'Unit' }
    , condition: { __typename?: 'LienWaiverConditionDetail', name: string, code: Types.LienWaiverCondition }, type: { __typename?: 'LienWaiverTypeDetail', name: string, code: Types.LienWaiverType }, project:
      | { __typename?: 'StandaloneProject', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Region', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market?: { __typename?: 'Market', id: string } | null | undefined, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Market', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Community', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Subdivision', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress?: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string } | null | undefined, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Lot', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Structure', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
      | { __typename?: 'Unit', id: string, name: string, legalDescription?: string | null | undefined, customerOwnerEntity?: { __typename?: 'CustomerOwnerEntity', id: string, name: string } | null | undefined, market: { __typename?: 'Market', id: string }, primaryHomeowner?: { __typename?: 'Client', id: string, fullName: string } | null | undefined, buildAddress: { __typename?: 'Address', id: string, street1: string, city: string, state: string, postalCode: string, country: string }, lotType: { __typename?: 'LotTypeDetail', code: Types.LotType, name: string } }
    , claimant:
      | { __typename?: 'Builder', id: string, name: string }
      | { __typename?: 'TradePartner', id: string, name: string }
    , payer:
      | { __typename?: 'Builder', id: string, name: string }
      | { __typename?: 'Client', id: string, name: string }
    , signatory?:
      | { __typename?: 'InternalUser', id: string, name: string }
      | { __typename?: 'TradePartnerContact', id: string, name: string }
     | null | undefined } };

export type LienWaiverLastPaidBillQueryVariables = Types.Exact<{
  filter: Types.BillFilter;
}>;


export type LienWaiverLastPaidBillQuery = { __typename?: 'Query', billsPage: { __typename?: 'BillsPage', entities: Array<{ __typename?: 'Bill', id: string, amountInCents: number }> } };

export type BillDataFragment = { __typename?: 'Bill', id: string, invoiceNumber: string };

export type InvoiceDataFragment = { __typename?: 'Invoice', id: string, invoiceNumber: string };

export type BuilderInfoFragment = { __typename?: 'Builder', id: string, name: string };

export type HomeownerInfoFragment = { __typename?: 'Client', id: string, name: string };

export const BillDataFragmentDoc = gql`
    fragment BillData on Bill {
  id
  invoiceNumber: tradePartnerNumber
}
    `;
export const InvoiceDataFragmentDoc = gql`
    fragment InvoiceData on Invoice {
  id
  invoiceNumber
}
    `;
export const BuilderInfoFragmentDoc = gql`
    fragment BuilderInfo on Builder {
  id
  name
}
    `;
export const HomeownerInfoFragmentDoc = gql`
    fragment HomeownerInfo on Client {
  id
  name: fullName
}
    `;
export const LienWaiverPdfDocument = gql`
    query LienWaiverPdf($lienWaiverId: ID!) {
  lienWaiver(id: $lienWaiverId) {
    id
    parent {
      ...BillData
      ...InvoiceData
    }
    payerName
    amountInCents
    throughDate
    condition {
      name
      code
    }
    type {
      name
      code
    }
    project {
      id
      name
      customerOwnerEntity {
        id
        name
      }
      market {
        id
      }
      primaryHomeowner {
        id
        fullName
      }
      buildAddress {
        id
        street1
        city
        state
        postalCode
        country
      }
      lotType {
        code
        name
      }
      legalDescription
    }
    claimant {
      ...BuilderInfo
      ...TradePartnerInfo
    }
    payer {
      ...BuilderInfo
      ...HomeownerInfo
    }
    signatory {
      ...Named
    }
  }
}
    ${BillDataFragmentDoc}
${InvoiceDataFragmentDoc}
${BuilderInfoFragmentDoc}
${TradePartnerInfoFragmentDoc}
${HomeownerInfoFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useLienWaiverPdfQuery__
 *
 * To run a query within a React component, call `useLienWaiverPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useLienWaiverPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLienWaiverPdfQuery({
 *   variables: {
 *      lienWaiverId: // value for 'lienWaiverId'
 *   },
 * });
 */
export function useLienWaiverPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LienWaiverPdfQuery, LienWaiverPdfQueryVariables> & ({ variables: LienWaiverPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>(LienWaiverPdfDocument, options);
      }
export function useLienWaiverPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>(LienWaiverPdfDocument, options);
        }
// @ts-ignore
export function useLienWaiverPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>;
export function useLienWaiverPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiverPdfQuery | undefined, LienWaiverPdfQueryVariables>;
export function useLienWaiverPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>(LienWaiverPdfDocument, options);
        }
export type LienWaiverPdfQueryHookResult = ReturnType<typeof useLienWaiverPdfQuery>;
export type LienWaiverPdfLazyQueryHookResult = ReturnType<typeof useLienWaiverPdfLazyQuery>;
export type LienWaiverPdfSuspenseQueryHookResult = ReturnType<typeof useLienWaiverPdfSuspenseQuery>;
export type LienWaiverPdfQueryResult = ApolloReactCommon.QueryResult<LienWaiverPdfQuery, LienWaiverPdfQueryVariables>;
export const LienWaiverLastPaidBillDocument = gql`
    query LienWaiverLastPaidBill($filter: BillFilter!) {
  billsPage(filter: $filter, order: {paidDate: DESC}, page: {offset: 0, limit: 1}) {
    entities {
      id
      amountInCents
    }
  }
}
    `;

/**
 * __useLienWaiverLastPaidBillQuery__
 *
 * To run a query within a React component, call `useLienWaiverLastPaidBillQuery` and pass it any options that fit your needs.
 * When your component renders, `useLienWaiverLastPaidBillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLienWaiverLastPaidBillQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLienWaiverLastPaidBillQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables> & ({ variables: LienWaiverLastPaidBillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>(LienWaiverLastPaidBillDocument, options);
      }
export function useLienWaiverLastPaidBillLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>(LienWaiverLastPaidBillDocument, options);
        }
// @ts-ignore
export function useLienWaiverLastPaidBillSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>;
export function useLienWaiverLastPaidBillSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<LienWaiverLastPaidBillQuery | undefined, LienWaiverLastPaidBillQueryVariables>;
export function useLienWaiverLastPaidBillSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>(LienWaiverLastPaidBillDocument, options);
        }
export type LienWaiverLastPaidBillQueryHookResult = ReturnType<typeof useLienWaiverLastPaidBillQuery>;
export type LienWaiverLastPaidBillLazyQueryHookResult = ReturnType<typeof useLienWaiverLastPaidBillLazyQuery>;
export type LienWaiverLastPaidBillSuspenseQueryHookResult = ReturnType<typeof useLienWaiverLastPaidBillSuspenseQuery>;
export type LienWaiverLastPaidBillQueryResult = ApolloReactCommon.QueryResult<LienWaiverLastPaidBillQuery, LienWaiverLastPaidBillQueryVariables>;